import * as React from "react";
const WikiHelpSectionLineIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 32 32",
  fill: "currentColor",
  width: "1em",
  height: "1em",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  d: "M16 4a11.922 11.922 0 0 0-8.485 3.515A11.922 11.922 0 0 0 4 16c0 2.114.555 4.183 1.607 6.002L4 28l5.998-1.607A11.982 11.982 0 0 0 16 28c3.205 0 6.219-1.248 8.485-3.515A11.922 11.922 0 0 0 28 16c0-3.205-1.248-6.219-3.515-8.485A11.922 11.922 0 0 0 16 4Z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M16 11.982c-1.078 0-1.953.847-1.953 1.89H12C12 11.734 13.792 10 16 10s4 1.734 4 3.872c0 1.406-.775 2.638-1.93 3.313l-.035.02-.03.015-.01.006a5.667 5.667 0 0 0-.02.012l-.003.001-.003.002a1.878 1.878 0 0 0-.943 1.618H14.98c0-1.406.775-2.633 1.925-3.31l.003-.002c.025-.015.071-.043.128-.072.552-.333.918-.927.918-1.603 0-1.043-.875-1.89-1.953-1.89Zm1.024 8.16V22h-2.048v-1.858h2.048Z",
  clipRule: "evenodd"
}));
export default WikiHelpSectionLineIcon;